import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import {
  saveInitialAssessmentAirway,
  setDepth,
  setSecuredVia,
  setTubeSize,
  setTubeSizeUnit,
  setTubeSizeUnitClient,
} from '../store/airway.actions'
import { AirwayConstants } from '../store/airway.constants'
import { getInitialAssessmentAirway } from '../selectors/getInitialAssessmentAirway.selectors'
import { IAssessmentsAirwayState } from '../store/airway.types'

export function* resetSecuredTubeDepthFields() {
  try {
    const initialAssessmentAirway: IAssessmentsAirwayState = yield select(getInitialAssessmentAirway)
    const { airStatus } = initialAssessmentAirway.prNabc

    if (airStatus?.id === 21 || airStatus?.id === 2) {
      yield put(setTubeSizeUnit('mm'))
      yield put(
        setTubeSizeUnitClient({
          id: 0,
          name: 'mm',
        })
      )
      yield put(saveInitialAssessmentAirway())
    } else {
      yield put(setSecuredVia(null))
      yield put(setTubeSize(''))
      yield put(setTubeSizeUnit(''))
      yield put(setTubeSizeUnitClient(null))
      yield put(setDepth(''))
      yield put(saveInitialAssessmentAirway())
    }
  } catch (e) {
    yield put(throwPcrException(`resetLengthBasedTapeMeasure() error: ${e}`))
  }
}
export function* resetSecuredTubeDepthFieldsSaga() {
  yield takeLatest([AirwayConstants.SET_STATUS], resetSecuredTubeDepthFields)
}
